<template>
  <v-icon v-if="stato === 0" color="red" class="material-icons">
    new_releases
  </v-icon>
  <v-icon v-else-if="stato == 1" color="gray" class="material-icons">
    schedule
  </v-icon>
  <v-icon v-else-if="stato == 2" color="green" class="material-icons">
    check_circle
  </v-icon>
  <v-icon v-else class="material-icons-outlined"> help_outline</v-icon>
</template>

<script>
export default {
  name: "stato-lettura",
  props: ["stato"], //0 – Nuovo, 1 – Letto da azienda, 2 – Letto da dipendente
};
</script>

<style>
</style>